import { Alert } from "@kyan/ui";

import { useTimeSyncWarningController } from "./TimeSyncWarning.controller";

export const TimeSyncWarning: React.FC = () => {
  const { isInvisible, description, dismiss } = useTimeSyncWarningController();

  if (isInvisible) return null;

  return (
    <Alert
      className="p-4"
      variant="notice"
      description={description}
      title="Device Time Out of Sync"
      closeIconProps={{
        onClick: dismiss,
      }}
    />
  );
};
